import { defineStore } from 'pinia'

import helpers from '~/helpers'
import JsonApiHelper from '~/helpers/json-api-helper'
import type { BrandData } from '~/types/brands'

export const messages = {
  failedToGetBrands: 'Не удалось получить бренды.',
  emptyBrands: 'Нет брендов',
}

type State = {
  filter: {
    query: string
  }
  isDataLoading: boolean
  page: {
    number: number
    size: number
  }
  brandsData: BrandData[]
  totalPages: number | null
  totalBrands: number | null
}

const initialState = (): State => ({
  filter: {
    query: ''
  },
  isDataLoading: false,
  page: {
    number: 1,
    size: 20
  },
  brandsData: [],
  totalPages: null,
  totalBrands: null
})

export const useBrandsStore = defineStore('brands', {
  state: () => initialState(),
  getters: {
    getBrands: (state: State) => state.brandsData
  },
  actions: {
    clearFilter (): void {
      this.filter = initialState().filter
    },
    clearBrands (): void {
      this.brandsData = []
    },
    deleteBrandById (brandId: string): void {
      const index = this.brandsData.findIndex((x: BrandData) => x.id === brandId)
      this.brandsData.splice(index, 1)
    },
    dispose (): void {
      this.clearFilter()
      this.clearBrands()
    },
    async fetchBrands ({ signal }: { signal?: AbortSignal } = {}): Promise<void> {
      const { $apiHelper, $toast } = useNuxtApp()

      this.isDataLoading = true
      this.totalPages = null

      const params = helpers.getParams([
        { name: 'filter[query]', value: this.filter.query, condition: true },
        { name: 'page[number]', value: this.page.number, condition: true },
        { name: 'page[size]', value: this.page.size, condition: true }
      ])

      try {
        const response = await $apiHelper.brands.getBrands(params, signal) as any
        const { data, meta } = JsonApiHelper.denormalizeResponse(response) as any

        this.totalBrands = meta.totalBrands
        this.totalPages = helpers.getTotalPages(meta.totalBrands, this.page.size)

        for (let i = 0; i < data.length; i++) {
          if (!this.brandsData.some(brand => brand.id === data[i].id)) {
            this.brandsData.push(data[i])
          }
        }
      } catch (error: any) {
        if (!signal?.aborted && error.name !== 'AbortError' && error.response) {
          console.error(error)
          $toast.error(messages.failedToGetBrands)
        }
      }

      this.isDataLoading = false
    },
  }
})
